export const generateDocumentId = (): string =>
    new Date().toISOString() + Math.floor(Math.random() * 1000000).toString();